import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../music24/components/primitives/SMLButton';
import { directorMessages as messages } from '../../messages/directorMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the director steps; each part uses its own slice of it */
import styles from '../DirectorSteps.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface AgainBoxProps {
  /** The example note: "less sad, more about the band…". */
  hint: string;
  button: string;
  disabled: boolean;
  onRun: (note: string) => void;
}

/** "Not it?" (design c1, d1): a note for the director and "Write 3 new ideas". Hidden on a phone. */
const AgainBoxComponent: React.FC<AgainBoxProps> = ({ hint, button, disabled, onRun }) => {
  const intl = useIntl();
  const [note, setNote] = useState('');
  return (
    <div className={styles.again}>
      <span className={styles.againLabel}>{intl.formatMessage(messages.notIt)}</span>
      <input
        className={clsx(styles.input, styles.againInput)}
        value={note}
        placeholder={hint}
        aria-label={intl.formatMessage(messages.noteLabel)}
        disabled={disabled}
        onChange={(event) => setNote(event.target.value)}
      />
      <SMLButton className={styles.small} disabled={disabled} onClick={() => onRun(note)}>
        {button}
      </SMLButton>
    </div>
  );
};

export const AgainBox = TypedMemo(AgainBoxComponent);
